import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import {
  SEARCH_SEARCH_AUTHORS_SET_DATA,
  SEARCH_SEARCH_AUTHORS_RESET_DATA,
} from 'rebook/apps/search/constants';


export function fetchInitialData(location = {}) {
  return async(dispatch, getState) => {
    const { ssr, searchAuthors: currentState } = getState();
    const limit = 10;
    const pageNumber = parseInt(get(ssr, 'query.page', 1));

    let newState = {
      pageNumber,
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
        isLoading: false,
        lastPageNumber: Math.ceil(location.state.authorsCount / limit),
      };
    }

    dispatch(setData(newState));

    if (!newState.authorsList || currentState.pageNumber !== pageNumber) {
      await dispatch(fetchAuthors(pageNumber));
    }
  };
}

export function fetchAuthors(pageNumber = 1) {
  return async(dispatch, getState) => {
    const { ssr, searchAuthors: currentState } = getState();
    const limit = 10;

    let query;

    if (ssr.query && ssr.query.q) {
      query = ssr.query.q;
    }
    else {
      query = currentState.query;
    }

    if (!query) {
      dispatch(setData({ isLoading: false }));
      return;
    }

    dispatch(setData({ isLoading: true }));

    let queryParams = {
      q: query,
      limit,
      offset: (pageNumber - 1) * limit,
    };

    const qs = queryString.stringify(queryParams);
    const url = `/api/search/authors/?${qs}`;

    return await fetchQuery(url, { apiVersion: 5, headers: ssr.headers })
      .then(({ data }) => {
        const lastPageNumber = Math.ceil(data.meta.total_count / limit);
        dispatch(setData({
          authorsList: data.objects,
          authorsCount: data.meta.total_count,
          query,
          pageNumber,
          lastPageNumber,
          isLoading: false,
        }));
      })
      .catch(({ data, resp, error }) => {
        if (resp.status === 404) {
          dispatch(Error404Actions.show());
        }
        else {
          Raven.captureMessage('failed to load author list author due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load author list author detail due to server error');
        }
      });
  };
}

function setSeoMeta() {
  return (dispatch, getState) => {
    const { ssr, searchAuthors: currentState } = getState();
    let authorName;

    if (ssr.query && ssr.query.q) {
      authorName = ssr.query.q;
    }
    else {
      authorName = currentState.query;
    }

    const title = `Все авторы по запросу «${authorName}»`;

    dispatch(SeoActions.setData({
      title,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    const { authorList } = payload;
    dispatch({
      type: SEARCH_SEARCH_AUTHORS_SET_DATA,
      payload,
    });
    if (authorList) {
      dispatch(setSeoMeta());
    }
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: SEARCH_SEARCH_AUTHORS_RESET_DATA,
    });
  };
}
